// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__19uxG","title":"Info_title__1DF5f","links":"Info_links__20ODN","link":"Info_link__1peLw","logo":"Info_logo__1lPHe"};